module.exports = __webpack_public_path__ + "img/icon-team-type-1.9febdf87.png";